export default {"src":"/_next/static/media/proMaskBg.b5b408d2.svg","height":178,"width":366,"blurWidth":0,"blurHeight":0};